import { ISliderWidget } from 'types/widgets';
import { px2em } from 'providers/creative/px2em/default_px2em';
import { getStyleDeclaration } from './get-style-declaration';
import { widgetSelector } from './helpers';
import { getWidgetGeometry } from '../recalculate-positions';

export function sliderWidget(widgetDescription: ISliderWidget) {
  const {
    placements = [],
    internalSizes,
    width,
    height,
    labelTextColor,
    thumbColor,
    thumbImageUrl,
    bgTrackColor,
    activeTrackColor,
  } = widgetDescription;
  const selector = widgetSelector(widgetDescription);
  const rules = [
    ...placements.map(getStyleDeclaration.positions(selector)),
    ...placements.map(getStyleDeclaration.size(selector)),
  ];

  rules.push([selector, [['gap', px2em(internalSizes.gap)]]]);

  const trackGeometry = getWidgetGeometry(
    {
      width: internalSizes.track.width,
      height: internalSizes.track.height,
    },
    width,
    height,
  );

  rules.push([
    `${selector} [data-role="trackContainer"]`,
    [['width', trackGeometry.relativeSize.width]],
  ]);

  rules.push([
    `${selector} [data-role="track"]`,
    [
      ['height', trackGeometry.relativeSize.height],
      ['background-color', bgTrackColor],
      ['border-radius', px2em(height / 2)],
    ],
  ]);

  const thumbGeometry = getWidgetGeometry(
    {
      width: internalSizes.thumb.size,
      height: internalSizes.thumb.size,
    },
    width,
    height,
  );

  rules.push([
    `${selector} [data-role="thumb"]`,
    [
      ['height', thumbGeometry.relativeSize.height],
      ['aspect-ratio', '1/1'],
      ['background-color', thumbColor],
    ],
  ]);

  if (thumbImageUrl) {
    rules.push([
      `${selector} [data-role="thumb"]`,
      [['background-image', `url(${thumbImageUrl})`]],
    ]);
  }

  rules.push([
    `${selector} [data-role="input"]`,
    [['width', `calc(100% + ${thumbGeometry.relativeSize.width.value}%)`]],
  ]);

  rules.push([
    `${selector} [data-role="progress"]`,
    [['background-color', activeTrackColor]],
  ]);

  if (internalSizes.label) {
    const labelSelector = `${selector} label`;

    rules.push([
      labelSelector,
      [
        ['font-size', px2em(internalSizes.label?.fontSize)],
        ['color', labelTextColor],
      ],
    ]);
  }

  return rules;
}
